module.exports = __webpack_public_path__ + "img/jg02-a7fbdd.jpg";